import { RefObject, useEffect, useState } from "react"

/**
 * Use this hook when you want to know if a user clicks
 * outside of a given component by ref.
 */
const useClickedOutsideRef = (ref: RefObject<any>) => {
  const [hasClickedOutside, setHasClickedOutside] = useState(false)

  useEffect(() => {
    function handleClickOutside(event: any) {
      setHasClickedOutside(ref.current && !ref.current.contains(event.target))
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [ref])

  return hasClickedOutside
}

export default useClickedOutsideRef
